import { useEffect, useState } from 'preact/hooks';

const THEME_ATTRIBUTE = 'data-theme';

function getTheme(container: HTMLElement): string | undefined {
  const closestThemeNode = container.closest<HTMLElement>(
    `[${THEME_ATTRIBUTE}]`
  );

  return (
    closestThemeNode?.dataset.theme ||
    document.documentElement.dataset.theme ||
    document.body?.dataset.theme
  );
}

export function useTheme(container: HTMLElement): string | undefined {
  const [theme, setTheme] = useState<string | undefined>(() =>
    getTheme(container)
  );

  useEffect(() => {
    const updateTheme = () => {
      setTheme(getTheme(container));
    };

    updateTheme();

    const observer = new MutationObserver(updateTheme);

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: [THEME_ATTRIBUTE],
    });

    if (document.body) {
      observer.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: [THEME_ATTRIBUTE],
      });
    }

    return () => observer.disconnect();
  }, [container]);

  return theme;
}
